import { withTogglePointFactory } from "@asosteam/asos-web-toggle-point-cuts";
import { pointCutPluginFactory } from "@asosteam/asos-web-toggle-point-optimizely";
import sdkInstanceProvider from "../../../client/sdkProvider";
import logger from "../../../lib/logger";
import { LOG_LEVEL_ERROR } from "../../../lib/logger/constants";
import { getFeatures } from "../../../featuresStore";

const plugin = pointCutPluginFactory({
  sdkInstanceProvider,
  getAudience: () => getFeatures()?.audience,
});

const withTogglePointFromFactory = withTogglePointFactory({
  getActiveFeatures: () => getFeatures()?.decisions,
  logError: logger[LOG_LEVEL_ERROR],
  plugins: [plugin],
});

const REACT_COMPONENT_STATICS = [
  "arguments",
  "caller",
  "length",
  "name",
  "prototype",
];

const copyStaticProperties = ({ Component, source }) => {
  Object.getOwnPropertyNames(source)
    .filter(
      (propertyName) =>
        !REACT_COMPONENT_STATICS.includes(propertyName) &&
        !Object.prototype.hasOwnProperty.call(Component, propertyName),
    )
    .forEach((propertyName) => {
      Object.defineProperty(
        Component,
        propertyName,
        Object.getOwnPropertyDescriptor(source, propertyName),
      );
    });
};

const withTogglePoint = (controlModule, featuresMap) => {
  const Component = withTogglePointFromFactory(controlModule, featuresMap);

  if (Component && controlModule?.default) {
    copyStaticProperties({ Component, source: controlModule.default });
  }

  return Component;
};

export default withTogglePoint;
